
/**
 * Ferme le panneau de déconnexion
 */
function CloseLogout() {

    $("#logoutBack").css('display', 'none');
    $('.logoutContainer').velocity({
        translateX: '-100%'
    });
}
window.CloseLogout = CloseLogout;


/**
 * Ouvre le panneau de deconnexion
 */
function OpenLogout() {

    //Ferme la navigation au besoin pour montrer le panneau de déconnexion au même endroit
    CloseLeftNav();

    //Si le masque de fond n'est pas déjà présent, on l'affiche
    if ($("#ModalBack").css('display') == 'none' && $('#sidenav-overlay').length == 0) {
        $("#logoutBack").css('display', 'block');
    }

    //Slide le panneau de déconnexion
    $('.logoutContainer').velocity({
        translateX: '0px'
    });
}
window.OpenLogout = OpenLogout;

/**
 * Ferme la navigation de gauche
 */
function CloseLeftNav() {

    //Retire le masque de fond
    $('#sidenav-overlay').remove();
    //Slide à fermé
    $('#slide-out').velocity({
        translateX: '-100%'
    });

    $('.burgerMenu').sideNav('hide');

}
window.CloseLeftNav = CloseLeftNav;

/**
 * Retour à la page précédente
 */
function NavBack() {

    window.history.back();

}
window.NavBack = NavBack;
